import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ChecklistMenuField, setValue, useFormField } from '@frontend/design-system';

export type LocationStringRecord = Record<string, string>;

export type filterSelectorError = {
  name: string;
  value: boolean;
};

interface Props {
  disabled?: boolean;
  allLocationsOption: LocationStringRecord;
  selectedLocationsValue?: string[];
  onChange: (args: string[]) => void;
  trackingId?: string;
}

export const LocationsSelector: FC<React.PropsWithChildren<Props>> = ({
  allLocationsOption,
  selectedLocationsValue,
  onChange,
  trackingId = 'location-selector',
}) => {
  const { t } = useTranslation('calls', { keyPrefix: 'calls-filter' });
  const locationsFieldProps = useFormField(
    {
      type: 'checklist',
      value: selectedLocationsValue,
    },
    [selectedLocationsValue]
  );

  const allLocationsSorted = Object.entries(allLocationsOption).sort(([, nameA], [, nameB]) =>
    nameA.localeCompare(nameB)
  );

  return (
    <div>
      <ChecklistMenuField
        {...locationsFieldProps}
        customRender={(props) => (
          <ChecklistMenuField.ChipInput
            {...props}
            onRemoveClick={(id) => {
              locationsFieldProps.onChange({ name: 'locations', value: [id] });
              // @ts-ignore - field types need to be fixed
              const nextState = setValue({ ...locationsFieldProps, type: 'checklist' }, id);
              onChange(nextState.value);
            }}
          />
        )}
        onChange={(e) => {
          locationsFieldProps.onChange(e);
          // @ts-ignore
          const nextState = setValue({ ...locationsFieldProps, type: 'checklist' }, e.value);
          onChange(nextState.value);
        }}
        label={t('Select Locations')}
        name='locations'
        data-tracking-id={trackingId}
      >
        {allLocationsSorted?.map(([id, locationName]) => (
          <ChecklistMenuField.Option key={id} value={id}>
            {locationName}
          </ChecklistMenuField.Option>
        ))}
      </ChecklistMenuField>
    </div>
  );
};
